import Notifications from './Notifications/init';
 import accounting from './portal-admin-accounting/init'; 
 import cms from './portal-admin-cms/init'; 
 import crud from './portal-admin-crud/init'; 
 import hr from './portal-admin-hr/init'; 
 import reports from './portal-admin-reports/init'; 
 
 export default [Notifications, accounting,cms,crud,hr,reports];
